import { render, staticRenderFns } from "./payResult.vue?vue&type=template&id=6b484ef7&scoped=true&"
import script from "./payResult.vue?vue&type=script&lang=js&"
export * from "./payResult.vue?vue&type=script&lang=js&"
import style0 from "./payResult.vue?vue&type=style&index=0&id=6b484ef7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b484ef7",
  null
  
)

export default component.exports